module.exports = __webpack_public_path__ + "img/icon_auth_one.890fe1a0.png";